



























































































































































































































































































































































































import {
  Component, Vue,
} from 'vue-property-decorator';
import AllianzDepositRecurringViewModel
  from '@/vue-app/view-models/allianz-dashboard/deposits/recurring_deposits/allianz-deposit-recurring-view-model';

@Component({
  name: 'RecurringDeposit',
})
export default class RecurringDeposit extends Vue {
  view_model = Vue.observable(
    new AllianzDepositRecurringViewModel(this),
  );

  created() {
    this.view_model.initialize();
  }
}

